var exports = {
  "AS": "x7f9a0e16--25dff1--item",
  "Sl": "x7f9a0e16--25dff1--image",
  "Qs": "x7f9a0e16--25dff1--content",
  "DD": "x7f9a0e16--25dff1--title",
  "h_": "x7f9a0e16--25dff1--description",
  "tO": "x7f9a0e16--25dff1--item-ltr",
};

module.exports = exports;
